// $(".button").click(function(){
//   $("#slidecarthq .slidecarthq").css("transform", "none");
// });



$(function() {  
	$( "#tabs_main" ).tabs({  
      heightStyle:"fill",  
      hide:"slideUp"
   });  
});  


$(document).ready(function() {
  $(".set > .acc_heading").on("click", function() {
    
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > .acc_heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > .acc_heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > .acc_heading").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
    
    if($( "#tabs_main .acc_heading" ).hasClass( "active" ) == true)
    {
    	$("#left-side-div").addClass("defaults");
    }
    else{
    	$("#left-side-div").removeClass("defaults");
    }
    
  });
});














jQuery(document).on("click",".feeling-luckybox-close",function(){

    jQuery(".feeling-luckybox").remove();

});

// toggle nav

		!function(s){"use strict";function n(s){return new RegExp("(^|\\s+)"+s+"(\\s+|$)")}var a,e,c;"classList"in document.documentElement?(a=function(s,n){return s.classList.contains(n)},e=function(s,n){s.classList.add(n)},c=function(s,n){s.classList.remove(n)}):(a=function(s,a){return n(a).test(s.className)},e=function(s,n){a(s,n)||(s.className=s.className+" "+n)},c=function(s,a){s.className=s.className.replace(n(a)," ")}),s.classie={hasClass:a,addClass:e,removeClass:c,has:a,add:e,remove:c}}(window);
		// end of classie js

		(function( window ){

			'use strict';

			var body = document.body,
			mask = document.createElement("div"),
			toggleSlideLeft = document.querySelector( ".toggle-slide-left" ),
			activeNav
			;
			mask.className = "mask";

			/* slide menu left */
			toggleSlideLeft.addEventListener( "click", function(){
				classie.add( body, "sml-open" );
				document.body.appendChild(mask);
				activeNav = "sml-open";
			} );

			/* hide active menu if close menu button is clicked */
			[].slice.call(document.querySelectorAll(".close-menu")).forEach(function(el,i){
				el.addEventListener( "click", function(){
					classie.remove( body, activeNav );
					activeNav = "";
					document.body.removeChild(mask);
				} );
			});

		})( window );

$('.toggle').click(function(){
$('.customheader #SiteNav').slideToggle();
});


jQuery(window).scroll(function(){
  var sticky = jQuery('header.site-header'),
      scroll = jQuery(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});



jQuery(function () {
  jQuery(".single-tabs p:not(:first-of-type)").css("display", "none");
  jQuery(".single-tabs h3:first-of-type").addClass("open");
  jQuery(".single-tabs h3").click(function () {
    jQuery(".open").not(this).removeClass("open").next().slideUp(300);
    jQuery(this).toggleClass("open").next().slideToggle(300);
  });
  
});

$(document).ready(function(){
  $('.clickme a').click(function(){
    $('.clickme a').removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).data('tag');
    $('.list').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
});



$(document).ready(function(){

$('.myproimg .row2 img').click(function(){
  //$('.myproimg .expand img').parent().removeClass('active');
   // $(this).parent().addClass('active');
});


  $(document).on('click','.myproimg img',function(){
   // $(this).parent().addClass('bigbox');   
    //$(this).parent().siblings().removeClass('bigbox');
   // $(this).parent().parent().siblings().find('.expand').removeClass('bigbox');
	//$(this).parent().parent().addClass('bigbox');
	//$(this).parent().siblings().removeClass('bigbox');
      
  });
  
  //SMWH --jQuery
  
  
  $('.samerow > div').on('click',function(){
  
  
      $('.samerow > div').removeClass('active-that');
    $(this).addClass('active-that');
    
     $('.samerow').removeClass('active-row');
    
  $(this).parent().addClass('active-row');
  
  })
   
 
$('button.btn.btn-primary.dropdown-toggle').on('click',function(){

alert();  
  
});    
 
});


function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();  




function openCity1(evt1, cityName1) {
  var j, tabcontent1, tablinks1;
  tabcontent1 = document.getElementsByClassName("tabcontent1");
  for (j = 0; j < tabcontent1.length; j++) {
    tabcontent1[j].style.display = "none";
  }
  tablinks1 = document.getElementsByClassName("tablinks1");
  for (j = 0; j < tablinks1.length; j++) {
    tablinks1[j].className = tablinks1[j].className.replace(" active", "");
  }
  document.getElementById(cityName1).style.display = "block";
  evt1.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen1").click();  


function openCity2(evt2, cityName2) {
  var j, tabcontent2, tablinks2;
  tabcontent2 = document.getElementsByClassName("tabcontent2");
  for (j = 0; j < tabcontent2.length; j++) {
    tabcontent2[j].style.display = "none";
  }
  tablinks2 = document.getElementsByClassName("tablinks2");
  for (j = 0; j < tablinks2.length; j++) {
    tablinks2[j].className = tablinks2[j].className.replace(" active", "");
  }
  document.getElementById(cityName2).style.display = "block";
  evt2.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen2").click();  

function openCity3(evt3, cityName3) {
  var j, tabcontent3, tablinks3;
  tabcontent3 = document.getElementsByClassName("tabcontent3");
  for (j = 0; j < tabcontent3.length; j++) {
    tabcontent3[j].style.display = "none";
  }
  tablinks3 = document.getElementsByClassName("tablinks3");
  for (j = 0; j < tablinks3.length; j++) {
    tablinks3[j].className = tablinks3[j].className.replace(" active", "");
  }
  document.getElementById(cityName3).style.display = "block";
  evt3.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen3").click();


function openCity4(evt4, cityName4) {
  var j, tabcontent4, tablinks4;
  tabcontent4 = document.getElementsByClassName("tabcontent4");
  for (j = 0; j < tabcontent4.length; j++) {
    tabcontent4[j].style.display = "none";
  }
  tablinks4 = document.getElementsByClassName("tablinks4");
  for (j = 0; j < tablinks4.length; j++) {
    tablinks4[j].className = tablinks4[j].className.replace(" active", "");
  }
  document.getElementById(cityName4).style.display = "block";
  evt4.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen4").click();







jQuery(function () {
  jQuery(".faq-list li:not(:first-child) p").css("display", "none");
  
  jQuery(".faq-list li:nth-child(1) h3").addClass("open");
 
  jQuery(".faq-list li h3").click(function () {
    jQuery(".open").not(this).removeClass("open").next().slideUp(300);
    jQuery(this).toggleClass("open").next().slideToggle(300);
  });
});






jQuery(document).ready(function(){
  
  jQuery(".shop-row-btns .btn1").click(function(){
    jQuery(".col1").css("display", "block");  
    jQuery(".col2").css("display", "none");
  });

  jQuery(".shop-row-btns .btn2").click(function(){
    jQuery(".col1").css("display", "none");  
    jQuery(".col2").css("display", "block");
  });
  
});
document.getElementById("defaultOpen4").click();  








  

function changeContent(){
  
  
  $('ul.dropdown-menu').toggle();
  
  
  $('.dropdown-toggle').toggleClass('open');
  
  
}  
  






 
  


// quantity selector

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
});


// single-page-faqs

  var elementOld = null;
var openClass = "Accordion__tab--open";

function toggleAccordion(element) {
    content = element.querySelector(".Accordion__tab__content");

    if(elementOld != null){
        elementOld.classList.remove(openClass);
        contentOld = elementOld.querySelector(".Accordion__tab__content");
        contentOld.style.maxHeight = "0px";
    }

    if(elementOld !== element){
        element.classList.add(openClass);
        content.style.maxHeight = content.scrollHeight + "px";
        elementOld = element;
    }else{
        elementOld = null;
    }
}







function multiplyBy()
{
        num1 = document.getElementById("firstNumber").value;
        num2 = document.getElementById("secondNumber").value;
        document.getElementById("result").innerHTML = num1 * num2;
}



jQuery("div#TextColumnImageWrapper-feature-columns-0").attr("data-aos-delay","000");
jQuery("div#TextColumnImageWrapper-feature-columns-2").attr("data-aos-delay","200");


jQuery("div#FeatureRowImageWrapper-163031308488170857").attr("data-aos","fade-left");


jQuery('.homeproduct ul.row.drive .s-col').click(function() { 
    document.location = 'https://welcome-to-the-tribe.myshopify.com/products/drive';
} );
jQuery('.homeproduct ul.row.align .s-col').click(function() { 
    document.location = 'https://welcome-to-the-tribe.myshopify.com/products/align';
} );
jQuery('.homeproduct ul.row.thrive .s-col').click(function() { 
    document.location = 'https://welcome-to-the-tribe.myshopify.com/products/thrive';
} );
jQuery('.homeproduct ul.row:nth-child(4) .s-col').click(function() { 
    document.location = '';
} );



// smart tabs 









